import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';

// Import context providers
import { AuthProvider } from './contexts/AuthContext';

// Import layouts
import Dashboard from './components/layout/Dashboard';
import ProtectedRoute from './components/layout/ProtectedRoute';

// Import pages
import Login from './pages/Login';
import Users from './pages/Users';
import UserDetail from './pages/UserDetail';
import Analytics from './pages/Analytics';
import Settings from './pages/Settings';
import DeviceReporting from './pages/DeviceReporting';

// Create theme
const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<Login />} />
            
            {/* Protected routes */}
            <Route path="/" element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }>
              <Route index element={<Users />} />
              <Route path="users/:userId" element={<UserDetail />} />
              <Route path="analytics" element={<Analytics />} />
              <Route path="device-reporting" element={<DeviceReporting />} />
              <Route path="settings" element={<Settings />} />
            </Route>
            
            {/* Redirect any unknown routes to home */}
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
